import CustomError from './CustomError'

export default class EntityAlreadyExistsException extends CustomError {
  constructor(message: string) {
    super(message)
  }
}
